/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Popup from './Popup/index'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import Tysiav2WarningIcon from 'DesignSystem/Svgs/Tysiav2WarningIcon/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/Address/Related/Content"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let sameEmailPersonsValueData = fromData.useDataFormat({ viewPath,
context: 'same_email_persons',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<Popup
  viewPath={`${viewPath}/Popup`}
/>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Popup/Content'))}
 {...isHoveredBind}
 className={`views-block ${styles.Vertical}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 backgroundColor={dtColorsNeutral200}
 borderColor={dtColorsNeutral200}
 color={dtColorsNeutral800}
 alignSelf="center"
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="same_email_persons"
 format="helpers.js getText"
 text={sameEmailPersonsValueData}
/>
<Tysiav2WarningIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2WarningIcon`}
 height={15}
 fill={dtColorsNeutral800}
 fill2={dtColorsNeutral800}
/>
</React.Fragment>
)}
</TysiaTag>
</button>
{children}
</React.Fragment>)
}